(function () {
    'use strict';

    run.parts.modals = function() {
        $(document).ready(function() {
            $(".jqmodal").modal({
                fadeDuration: 700,
            });
        });
    };
})();